import React from "react";
import Styled, { keyframes } from "styled-components";
import ProjectCard from "./ProjectCard";
import Image1 from "../asset/resumeMaker.png";
import Image2 from "../asset/pracbook.png";
import Image3 from "../asset/froshHub.png";
import Image4 from "../asset/jojo.webp"
function ProjectsCardCont() {
  const data = [
    {
      image: Image1,
      link: "http://make-my-resumes.herokuapp.com/",
      proName:"Resume Maker"
    },
    {
      image: Image2,
      link: "http://pracbook.herokuapp.com/",
      proName:"Pracbook"

    },
    {
      image: Image3,
      link: "https://rupin-1801.github.io/FroshHub/",
      proName:"froshHub"
    },
    {
      image: Image4,
      link: "https://t.me/JOJO198Bot",
      proName:"JoJo bot"
    },
  ];
  return (
    <MainCont>
      {data.map((temp, i) => {
        return <ProjectCard value={temp.image} link={temp.link} proName={temp.proName}/>;
      })}
    </MainCont>
  );
}

const MainCont = Styled.div`
    display:flex;
    gap:2rem;
    justify-content:center;
    flex-wrap:wrap;
    margin:1rem 0 2rem 0;
    min-height:fit-content;
`;
export default ProjectsCardCont;
